export enum Mode {
  Dark = "dark",
  Light = "light",
}

export const getAllModes = () => [Mode.Dark, Mode.Light];

export const isDarkMode = (mode: Mode) => mode === Mode.Dark;
